import { Zeeguu_API } from "./classDef";
import "./feature_toggles";
import "./accounts";
import "./userDetails";
import "./userWords";
import "./userInterests";
import "./userArticles";
import "./translations";
import "./exercises";
import "./exercise_sessions";
import "./reading_sessions";
import "./userStats";
import "./speech";
import "./activityLogging";
import "./ownTexts";
import "./student";
import "./teacher";
import "./studentStatsForTeachers";
import "./nlp";
import "./userVideos";
import "./watching_sessions";
import "./dailyAudio";

export default Zeeguu_API;
